const posts_accordion = document.querySelectorAll( '.posts-accordion .wp-block-media-text' );

if ( posts_accordion ) {
  const wWidth = window.innerWidth;
  Array.from( posts_accordion ).forEach( el => {
    el.addEventListener( 'click', function( event ) {
      if ( !this.classList.contains( 'active' ) ) {
        const ele = this.parentElement.children;
        Array.from( ele ).forEach( el => el.classList.remove( "active" ) )
        this.classList.add( 'active' );
        if ( wWidth < 768 ) {
          this.scrollIntoView( { behavior: "smooth", block: "start", inline: "nearest" } );
        }
        return;
      }
    } );
  } );
}
